import { DOCUMENT } from '@angular/common';
import {
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  viewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AdminButtonComponent } from './admin-button.component';
import { AdminIconComponent } from './admin-icon.component';
import { AdminNotificationPanelComponent } from './admin-notification-panel.component';
import { NotificationsService } from '../services/notifications.service';

@Component({
  selector: 'app-admin-notification-bell',
  standalone: true,
  imports: [AdminButtonComponent, AdminIconComponent, AdminNotificationPanelComponent],
  template: `
    <div class="cg-admin-navbar__notif" #notifRoot>
      <app-admin-button
        variant="ghost"
        type="button"
        aria-label="Notifications"
        [attr.aria-expanded]="notifications.panelOpen()"
        (click)="onBellClick($event)"
      >
        <span class="cg-admin-navbar__notif-trigger">
          <app-admin-icon name="bell" [size]="20" />
          @if (notifications.unreadCount() > 0) {
            <span class="cg-admin-navbar__notif-badge" aria-hidden="true">
              {{ badgeLabel() }}
            </span>
          }
        </span>
      </app-admin-button>

      <app-admin-notification-panel />
    </div>
  `,
})
export class AdminNotificationBellComponent implements OnInit {
  private readonly doc = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);
  private readonly notifRoot = viewChild<ElementRef<HTMLElement>>('notifRoot');

  readonly notifications = inject(NotificationsService);

  ngOnInit(): void {
    this.notifications.bindLifecycle(this.destroyRef);

    fromEvent<MouseEvent>(this.doc, 'click')
      .pipe(
        filter(() => this.notifications.panelOpen()),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        const root = this.notifRoot()?.nativeElement;
        if (root && !root.contains(event.target as Node)) {
          this.notifications.closePanel();
        }
      });
  }

  onBellClick(event: MouseEvent): void {
    event.stopPropagation();
    this.notifications.togglePanel();
  }

  badgeLabel(): string {
    const count = this.notifications.unreadCount();
    return count > 99 ? '99+' : String(count);
  }
}
